module.exports = __webpack_public_path__ + "51e9d1ece73a737806edde2530d88348.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/course-carousel.jpg
 ** module id = 510
 ** module chunks = 1
 **/